import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoGallery = loadable(() => import(/* webpackChunkName: "content/guestSitePhotoGallery" */ '.'), 'PhotoGallery');
